import { Box, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import "./Articles.css";

const Articles = () => {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { data, loading, error } = useFetch(
    "https://abc-backend.onrender.com/api/articles"
  );
  console.log(data);
  return (
    <div>
      <Container>
        <div className="service">
          <Box className="side_title">
            <Typography variant="h2">Articles</Typography>
          </Box>
          <Grid container spacing={5}>
            {data.map((arData) => (
              <Grid item xs={12} lg={6} md={6}>
                <Link to={`/article-details/${arData._id}`}>
                  <Box className="articlesCard">
                    <img
                      src={PF + arData.image}
                      alt="article image"
                      className="article_image"
                    />
                    <Box className="articlesCard_text">
                      <Typography variant="h5">
                        {arData.desc?.slice(0, 30)}
                      </Typography>
                      <Typography variant="h5">
                        {arData.desc?.slice(30, 1000)}
                      </Typography>
                    </Box>
                  </Box>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Articles;
